import React from 'react'
import ChooseTipoDePagamentoDialog from './chooseTipoDePagamentoDialog'
import ChooseTipoDreCompetenciaDialog from './chooseTipoDreCompetenciaDialog'

class InputChooseTipoDreCompetencia extends React.Component {

    state = {
        chooseTipoDreCompetenciaDialogVisible: false,

    }

    componentDidMount(){
        if(this.props.renderDialogOnMount){
            this.setState({chooseTipoDreCompetenciaDialogVisible: true})
        }
    }

    hideTipoDePagamentoDialog = () => {
        this.setState({chooseTipoDreCompetenciaDialogVisible: false})

        if(this.props.hideDialog){
            this.props.hideDialog()
        }
    }

    handleSelectionTipoDreCompetenciaChange = async (tipoDreCompetencia) => {
        const label = tipoDreCompetencia.descricao
        this.props.handleSelectionTipoDreCompetenciaChange(tipoDreCompetencia, label)
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    inputClick = () => {
        this.setState({chooseTipoDreCompetenciaDialogVisible: true})
    }

    generateLabel = () => {
        var label = "Tipo DRE Competência"

        if(this.props.optional){
            label+=" (Opcional)"
        }

        return label
    }

    render(){

        const renderInput = () => {
            return (
                <>
                <label >{this.generateLabel()}</label>
                <input
                    type="text"
                    className={"form-control " + this.props.inputErrorClass}
                    readOnly
                    value = {this.props.selectedTipoDreCompetenciaLabel}
                    name="selectedTipoDreCompetenciaLabel"
                    onClick={this.inputClick}
                    onKeyPress={this.handleKeyPress}
                    placeholder="Nenhum Tipo DRE Competência selecionado..."
                    disabled={this.props.disabled}
                />
                {/* <div className="invalid-feedback">{this.props.errorTipoDePagaentoMessage}</div>  */}
                <div className="invalid-feedback">Selecione o Tipo DRE Competência</div> 
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {renderInput()}
                    </>
                )
            }
            else {
                return (
                    <>
                    {/* <div className="row"> */}
                    {/* <div className="col-md-4"> */}
                    {renderInput()}
                    {/* </div> */}
                    {/* </div> */}
                    </>
                )
            }
        }

        return(
            <>
                {/* <div className="col-md-4">
                   
                    </div> */}
                {renderHTMLFormat()}

                    
                <ChooseTipoDreCompetenciaDialog
                    header={this.generateLabel()}
                    visible={this.state.chooseTipoDreCompetenciaDialogVisible || this.props.forceShowDialog}
                    list={this.props.tipoDePagamentoList}
                    contaBancariaId={this.props.contaBancariaId}
                    search={this.props.search}
                    forceUpdate={this.props.forceUpdate}
                    doneForceUpdate={this.props.doneForceUpdate}
                    hideDialog={this.hideTipoDePagamentoDialog}
                    handleSelectionTipoDreCompetenciaChange={this.handleSelectionTipoDreCompetenciaChange}
                    provisoesAPagar={this.props.provisoesAPagar}
                    fichaDePagamento={this.props.fichaDePagamento}
                />

            </>
        )

    }

}

export default InputChooseTipoDreCompetencia